import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceGroupService} from "../customer-instance-group.service";
import {CustomerInstanceGroupData} from "../customer-instance-group.data";

@Component({
    selector: "fhm-customer-instance-group-search-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./customer-instance-group-search-page.component.html",
    providers: [CustomerInstanceGroupService],
    standalone: false
})
export class CustomerInstanceGroupSearchPageComponent implements OnInit {

    gridData: CustomerInstanceGroupData[] = [];


    constructor(private customerInstanceGroupService: CustomerInstanceGroupService,
                private router: Router,
                private errorHandler: ErrorHandlerService,
                private spinnersService: FUISpinnersService) {
    }

    ngOnInit(): void {
        this.load();

    }

    async load(): Promise<void> {
        this.spinnersService.open();
        try {
            this.gridData = await this.customerInstanceGroupService.getCustomerInstanceGroups();
        } catch (error) {
            this.errorHandler.handleErrorResponse(error);
        } finally {
            this.spinnersService.close();
        }
    }

    addNew(): void {
        this.router.navigate(["/main/customer-instance-group-edit/new"]);
    }

    recordSelected(record: any): void {
        this.router.navigate(["/main/customer-instance-group-edit/" + record["id"]]);
    }
}
